import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"
import type Session from "cc-frontend/services/session"
import { includes } from "lodash-es"

export default class DateRow extends Component {
  @service("ember-store") store!: EmberStore
  @service session!: Session
  @service lessonEditor!: LessonEditor

  // args
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit
  arrowUpDown!: Function
  canBeEditable!: boolean
  cardStack!: CardStack
  selectedDateStrings!: Array<string>
  date!: Record<string, any>
  onLessonSelect!: Function
  isSelectable!: boolean
  hasFocus!: boolean

  @computed("selectedDateStrings.[]")
  get isSelected() {
    let dates = this.selectedDateStrings
    return includes(dates, this.date.dateString)
  }

  @computed("canBeEditable", "permissions.length")
  get isReadOnly() {
    if (this.canBeEditable === false) return true
    if (this.cardStack) {
      return !includes(this.cardStack.meta.permissions, "can-edit-plan")
    } else {
      return false
    }
  }

  // TODO Make up down arrow focus work for correct permissions
  @action
  onKeyDown(event) {
    if (event.keyCode === 38) this.arrowUpDown("up")
    if (event.keyCode === 40) this.arrowUpDown("down")
  }

  @action
  onTitleIntermediateEdit(value) {
    if (this.session.isAuthenticated !== true) return
    this.lessonEditor.editTitle(this.modelsNeededForFirstEdit, this.cardStack.id, value, false)
  }

  @action
  onTitleEdited(value) {
    if (this.session.isAuthenticated !== true) return
    this.lessonEditor.finishEditingTitle(
      this.modelsNeededForFirstEdit,
      this.cardStack.id,
      value,
      this.cardStack.attributes.title || null
    )
  }

  @action
  lessonSelect(cardStackId, dateString) {
    if (this.onLessonSelect) {
      this.onLessonSelect(cardStackId, dateString)
    }
  }
}
